/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import cx from 'classnames';
import { ChevronRightLightIcon } from 'components/common';
import { ELSButton, ELSFlex, ELSIcon } from 'components/common/els';
import './tile.scss';

export interface TileProps {
  title: string;
  active: boolean;
  onClick: VoidFunction;
}

const Tile = (props: TileProps) => (
  <ELSButton type="debuttonize" className="c-els-button--expanded" onClick={props.onClick} ariaLabel={props.active ? 'Chart has been edited' : 'Chart has not been edited'}>
    <div className={cx('tile', { 'tile--active': props.active })}>
      <ELSFlex className="tile__icon-wrapper" middle>
        {props.active && <ELSIcon name="checkmark" color="primary" />}
      </ELSFlex>
      <ELSFlex className="tile__content-wrapper" column>
        <ELSFlex left middle>
          <div className={cx('tile__title', { 'u-els-margin-right': !props.active })}>{props.title}</div>
          {!props.active && <ChevronRightLightIcon />}
        </ELSFlex>
        {props.active && (
          <ELSFlex className="u-els-margin-top-1o2" left middle>
            <div className="u-els-font-size-intro u-els-line-height-single u-els-margin-right-1o2">Make Edits</div>
            <ChevronRightLightIcon size="small" />
          </ELSFlex>
        )}
      </ELSFlex>
    </div>
  </ELSButton>
);

Tile.displayName = 'Tile';
export default Tile;
